const TRIAL_NOTIFICATION_HEIGHT = '56px';

export default TRIAL_NOTIFICATION_HEIGHT;
